// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SendSmsInput-module__font-s-10___yuJiU {
  font-size: 10px !important;
}

.SendSmsInput-module__font-s-12___HVQY1 {
  font-size: 12px !important;
}

.SendSmsInput-module__font-s-13___N2ATT {
  font-size: 13px !important;
}

.SendSmsInput-module__font-s-14___TsHUr {
  font-size: 14px !important;
}

.SendSmsInput-module__font-s-15___W15rb {
  font-size: 15px !important;
}

.SendSmsInput-module__font-s-16___D9dkT {
  font-size: 16px !important;
}

.SendSmsInput-module__font-s-18___H7qs3 {
  font-size: 18px !important;
}

.SendSmsInput-module__font-s-20___S6F_6 {
  font-size: 20px !important;
}

.SendSmsInput-module__font-s-22___ZtepK {
  font-size: 22px !important;
}

.SendSmsInput-module__font-s-28___RyTZJ {
  font-size: 28px !important;
}

.SendSmsInput-module__font-w-400___M3vvp {
  font-weight: 400 !important;
}

.SendSmsInput-module__font-w-500___pZDdz {
  font-weight: 500 !important;
}

.SendSmsInput-module__font-w-600___gv7Iq {
  font-weight: 600 !important;
}

.SendSmsInput-module__font-w-700___DLDaP {
  font-weight: 700 !important;
}

.SendSmsInput-module__p-5___LahIl {
  padding: 5px !important;
}

.SendSmsInput-module__p-12___LLx4b {
  padding: 12px !important;
}

.SendSmsInput-module__p-16___i1XOE {
  padding: 16px !important;
}

.SendSmsInput-module__p-30___ikEGA {
  padding: 30px !important;
}

.SendSmsInput-module__p-b-0___LCzGO {
  padding-bottom: 0 !important;
}

.SendSmsInput-module__p-b-5___a4gYP {
  padding-bottom: 5px !important;
}

.SendSmsInput-module__p-b-10___qnHIs {
  padding-bottom: 10px !important;
}

.SendSmsInput-module__p-b-12___d6MLK {
  padding-bottom: 12px !important;
}

.SendSmsInput-module__p-b-16___PHxGH {
  padding-bottom: 16px !important;
}

.SendSmsInput-module__p-b-18___SF0PY {
  padding-bottom: 18px !important;
}

.SendSmsInput-module__p-b-20___f4kGQ {
  padding-bottom: 20px !important;
}

.SendSmsInput-module__p-b-25___XyTDQ {
  padding-bottom: 25px !important;
}

.SendSmsInput-module__p-b-30___pjAlB {
  padding-bottom: 30px !important;
}

.SendSmsInput-module__p-b-50___mKyeC {
  padding-bottom: 50px !important;
}

.SendSmsInput-module__p-t-0___iIcu4 {
  padding-top: 0 !important;
}

.SendSmsInput-module__p-t-12___HOJAx {
  padding-top: 12px !important;
}

.SendSmsInput-module__p-t-16___GSAmf {
  padding-top: 16px !important;
}

.SendSmsInput-module__p-t-18___lqMJs {
  padding-top: 18px !important;
}

.SendSmsInput-module__p-t-20___Z5kLh {
  padding-top: 20px !important;
}

.SendSmsInput-module__p-t-30___jw7LQ {
  padding-top: 30px !important;
}

.SendSmsInput-module__p-t-40___luf6i {
  padding-top: 40px !important;
}

.SendSmsInput-module__p-t-50___y48Pm {
  padding-top: 50px !important;
}

.SendSmsInput-module__p-l-20___ynDJe {
  padding-left: 20px !important;
}

.SendSmsInput-module__p-l-30___H5cgx {
  padding-left: 30px !important;
}

.SendSmsInput-module__p-l-40___aXMqP {
  padding-left: 40px !important;
}

.SendSmsInput-module__p-r-16___v6vzJ {
  padding-right: 16px !important;
}

.SendSmsInput-module__p-r-20____RGXz {
  padding-right: 20px !important;
}

.SendSmsInput-module__p-r-30___jUGKR {
  padding-right: 30px !important;
}

.SendSmsInput-module__p-r-50___lZ33F {
  padding-right: 50px !important;
}

.SendSmsInput-module__p-r-60___MySm1 {
  padding-right: 60px !important;
}

.SendSmsInput-module__m-b-1___yRml6 {
  margin-bottom: 1px !important;
}

.SendSmsInput-module__m-b-2___YBJWK {
  margin-bottom: 2px !important;
}

.SendSmsInput-module__m-b-6___d3CWo {
  margin-bottom: 6px !important;
}

.SendSmsInput-module__m-b-8___BJ23i {
  margin-bottom: 8px !important;
}

.SendSmsInput-module__m-b-10___faN_b {
  margin-bottom: 10px !important;
}

.SendSmsInput-module__m-b-14___mEqBh {
  margin-bottom: 14px !important;
}

.SendSmsInput-module__m-b-16___ayQK_ {
  margin-bottom: 16px !important;
}

.SendSmsInput-module__m-b-20___VxATl {
  margin-bottom: 20px !important;
}

.SendSmsInput-module__m-b-22___LXBXX {
  margin-bottom: 22px !important;
}

.SendSmsInput-module__m-b-24___qTO4x {
  margin-bottom: 24px !important;
}

.SendSmsInput-module__m-b-30___Hj5Ht {
  margin-bottom: 30px !important;
}

.SendSmsInput-module__m-b-32___sj7Hh {
  margin-bottom: 32px !important;
}

.SendSmsInput-module__m-b-40___MtvQS {
  margin-bottom: 40px !important;
}

.SendSmsInput-module__m-t-2___dGvU8 {
  margin-top: 2px !important;
}

.SendSmsInput-module__m-t-3___8AhPy {
  margin-top: 3px !important;
}

.SendSmsInput-module__m-t-4___VHXya {
  margin-top: 4px !important;
}

.SendSmsInput-module__m-t-5___xmb_i {
  margin-top: 5px !important;
}

.SendSmsInput-module__m-t-8___cHSC9 {
  margin-top: 8px !important;
}

.SendSmsInput-module__m-t-10___JkgWM {
  margin-top: 10px !important;
}

.SendSmsInput-module__m-t-15___QTPFn {
  margin-top: 15px !important;
}

.SendSmsInput-module__m-t-16___sp0Z7 {
  margin-top: 16px !important;
}

.SendSmsInput-module__m-t-20___bWptq {
  margin-top: 20px !important;
}

.SendSmsInput-module__m-t-22___hdmDF {
  margin-top: 22px !important;
}

.SendSmsInput-module__m-t-30___TDYkZ {
  margin-top: 30px !important;
}

.SendSmsInput-module__m-t-32___eRqwJ {
  margin-top: 32px !important;
}

.SendSmsInput-module__m-l-auto___JJQz5 {
  margin-left: auto !important;
}

.SendSmsInput-module__m-l-4___oD9g_ {
  margin-left: 4px !important;
}

.SendSmsInput-module__m-l-5___hYC88 {
  margin-left: 5px !important;
}

.SendSmsInput-module__m-l-6___jS8CR {
  margin-left: 6px !important;
}

.SendSmsInput-module__m-l-8___B8Tq2 {
  margin-left: 8px !important;
}

.SendSmsInput-module__m-l-10____FyYw {
  margin-left: 10px !important;
}

.SendSmsInput-module__m-l-16___q0eyK {
  margin-left: 16px !important;
}

.SendSmsInput-module__m-l-20____ZmmW {
  margin-left: 20px !important;
}

.SendSmsInput-module__m-l-24___FXgZ8 {
  margin-left: 24px !important;
}

.SendSmsInput-module__m-l-30___WJU4C {
  margin-left: 30px !important;
}

.SendSmsInput-module__m-l-35___bjKk2 {
  margin-left: 35px !important;
}

.SendSmsInput-module__m-l-40___GOOWi {
  margin-left: 40px !important;
}

.SendSmsInput-module__m-r-8___tRfM_ {
  margin-right: 8px !important;
}

.SendSmsInput-module__m-r-10___lLfcO {
  margin-right: 10px !important;
}

.SendSmsInput-module__m-r-16___INMv7 {
  margin-right: 16px !important;
}

.SendSmsInput-module__m-r-20___ma2Cs {
  margin-right: 20px !important;
}

.SendSmsInput-module__m-r-24___jOJW8 {
  margin-right: 24px !important;
}

.SendSmsInput-module__m-r-30___E4m_w {
  margin-right: 30px !important;
}

.SendSmsInput-module__m-r-40___Wi4op {
  margin-right: 40px !important;
}

.SendSmsInput-module__border-r-3___PaOWt {
  border-radius: 3px !important;
}

.SendSmsInput-module__border-r-4___xFoEY {
  border-radius: 4px !important;
}

.SendSmsInput-module__border-r-6___ZPCZM {
  border-radius: 6px !important;
}

.SendSmsInput-module__border-r-10___Frp40 {
  border-radius: 10px !important;
}

.SendSmsInput-module__border-r-12___ZIeRK {
  border-radius: 12px !important;
}

.SendSmsInput-module__border-r-16___akmDU {
  border-radius: 16px !important;
}

.SendSmsInput-module__border-r-50___k_QID {
  border-radius: 50% !important;
}

.SendSmsInput-module__primary-border___oDWf1 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.SendSmsInput-module__primary-border-b___rRU_5 {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.SendSmsInput-module__primary-border-t___pp6PW {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.SendSmsInput-module__primary-border-l___XBEAH {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.SendSmsInput-module__primary-border-r___wiheB {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.SendSmsInput-module__secondary-border___vpGCy {
  border: 1px solid #637768;
}

.SendSmsInput-module__secondary-border-b___cNyTg {
  border-bottom: 1px solid #637768;
}

.SendSmsInput-module__secondary-border-t___X7rws {
  border-top: 1px solid #637768;
}

.SendSmsInput-module__secondary-border-l___y8ive {
  border-left: 1px solid #637768;
}

.SendSmsInput-module__secondary-border-r___je4On {
  border-right: 1px solid #637768;
}

.SendSmsInput-module__gap-0___fHAzG {
  gap: 0 !important;
}

.SendSmsInput-module__gap-2___utnM4 {
  gap: 2px !important;
}

.SendSmsInput-module__gap-4___kVO_R {
  gap: 4px !important;
}

.SendSmsInput-module__gap-5___Jo0Q5 {
  gap: 5px !important;
}

.SendSmsInput-module__gap-6___kW1gT {
  gap: 6px !important;
}

.SendSmsInput-module__gap-8___AnPlk {
  gap: 8px !important;
}

.SendSmsInput-module__gap-10___u2Ld1 {
  gap: 10px !important;
}

.SendSmsInput-module__gap-12___aq44S {
  gap: 12px !important;
}

.SendSmsInput-module__gap-14___zNqTd {
  gap: 14px !important;
}

.SendSmsInput-module__gap-16___awOmL {
  gap: 16px !important;
}

.SendSmsInput-module__gap-18___E9nYg {
  gap: 18px !important;
}

.SendSmsInput-module__gap-20___QUdgJ {
  gap: 20px !important;
}

.SendSmsInput-module__gap-24___eCDI3 {
  gap: 24px !important;
}

.SendSmsInput-module__gap-26___xYdP8 {
  gap: 26px !important;
}

.SendSmsInput-module__gap-30___G5nmY {
  gap: 30px !important;
}

.SendSmsInput-module__gap-32___uQCjV {
  gap: 32px !important;
}

.SendSmsInput-module__gap-40___seTT5 {
  gap: 40px !important;
}

.SendSmsInput-module__gap-50___VzSyE {
  gap: 50px !important;
}

.SendSmsInput-module__flex-1___DsMBb {
  flex: 1;
}

.SendSmsInput-module__flex-none___lMlLV {
  flex: none !important;
}

.SendSmsInput-module__flex-column___ZFAy7 {
  display: flex;
  flex-direction: column !important;
}

.SendSmsInput-module__flex-row___BT9c1 {
  display: flex;
  flex-direction: row !important;
}

.SendSmsInput-module__vertically-centered___kUOs5 {
  display: flex;
  align-items: center !important;
}

.SendSmsInput-module__horizontally-centered___Xmya0 {
  display: flex;
  justify-content: center !important;
}

.SendSmsInput-module__horizontally-end___FY_CJ {
  display: flex;
  justify-content: end !important;
}

.SendSmsInput-module__vertically-start___wD1yS {
  display: flex;
  align-items: start !important;
}

.SendSmsInput-module__space-between___NXAar {
  display: flex;
  justify-content: space-between !important;
}

.SendSmsInput-module__flex-wrap___U_MZE {
  flex-wrap: wrap !important;
}

.SendSmsInput-module__height-100___m1Hu4 {
  height: 100%;
}

.SendSmsInput-module__width-50___vItYn {
  width: 50% !important;
}

.SendSmsInput-module__width-100___XrVQn {
  width: 100%;
}

.SendSmsInput-module__cursor-pointer___Ln6Gu {
  cursor: pointer;
}

.SendSmsInput-module__cursor-not-allowed___CQ4A6 {
  cursor: not-allowed !important;
}

.SendSmsInput-module__absolute-centered___jpsAc {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.SendSmsInput-module__absolute___WBjbb {
  position: absolute;
}

.SendSmsInput-module__relative___VDmm8 {
  position: relative;
}

.SendSmsInput-module__fixed___uVQEc {
  position: fixed;
}

.SendSmsInput-module__visible___6WGw8 {
  opacity: 1;
}

.SendSmsInput-module__invisible___gRaaA {
  opacity: 0;
}

.SendSmsInput-module__col-90___Zbp6A {
  width: 90% !important;
}

.SendSmsInput-module__col-auto___a0FRz {
  width: auto !important;
}

.SendSmsInput-module__medical-tabs___sLnJ2 {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.SendSmsInput-module__medical-table-new___gQSp8 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.SendSmsInput-module__medical-table-new___gQSp8:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.SendSmsInput-module__medical-table-new___gQSp8::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.SendSmsInput-module__medical-table-new___gQSp8::-webkit-scrollbar-track {
  display: none;
}
.SendSmsInput-module__medical-table-new___gQSp8.SendSmsInput-module__no-pagination___TsRrz {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.SendSmsInput-module__medical-table-new___gQSp8.SendSmsInput-module__no-pagination___TsRrz:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.SendSmsInput-module__medical-table-new___gQSp8.SendSmsInput-module__no-pagination___TsRrz::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.SendSmsInput-module__medical-table-new___gQSp8.SendSmsInput-module__no-pagination___TsRrz::-webkit-scrollbar-track {
  display: none;
}

.SendSmsInput-module__medical-table-empty___b1WAF {
  padding: 14px 40px !important;
}

.SendSmsInput-module__icon-btn___Pburf {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.SendSmsInput-module__search-icon___I80wP {
  width: 24px;
  height: 24px;
  align-self: center;
}

.SendSmsInput-module__disable-select___wpQDl {
  user-select: none;
}

.SendSmsInput-module__break-word___lJz_f {
  word-break: break-word;
}

.SendSmsInput-module__popup-clear-btn___tXQ1b {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.SendSmsInput-module__scroll-m-b-20___WhGzM {
  scroll-margin-bottom: 20px;
}

.SendSmsInput-module__container___iiaou {
  position: fixed;
  bottom: 0;
  margin: 40px auto;
  display: flex;
  align-self: center;
  width: 100%;
  justify-content: center;
}
.SendSmsInput-module__container___iiaou .SendSmsInput-module__inputContainer___F9Tgn {
  width: 50%;
  position: relative;
}
.SendSmsInput-module__container___iiaou .SendSmsInput-module__inputContainer___F9Tgn .SendSmsInput-module__input___bdQMQ {
  background-color: #fdfcfa;
  border-color: #ece7e7;
  padding-right: 100px;
}
.SendSmsInput-module__container___iiaou .SendSmsInput-module__inputContainer___F9Tgn .SendSmsInput-module__input___bdQMQ.SendSmsInput-module__error___CsN5Z {
  background-color: rgba(219, 40, 40, 0.1);
}
.SendSmsInput-module__container___iiaou .SendSmsInput-module__buttonContainer___yScpa {
  display: flex;
  position: absolute;
  right: 26%;
  top: 21px;
  gap: 20px;
}
.SendSmsInput-module__container___iiaou .SendSmsInput-module__buttonContainer___yScpa .SendSmsInput-module__sendButton___WUQI8 {
  display: flex;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: #375844;
  cursor: pointer;
}
.SendSmsInput-module__container___iiaou .SendSmsInput-module__buttonContainer___yScpa .SendSmsInput-module__sendButton___WUQI8.SendSmsInput-module__disabled___vHtIc {
  opacity: 0.33;
  cursor: not-allowed;
}
.SendSmsInput-module__container___iiaou .SendSmsInput-module__buttonContainer___yScpa .SendSmsInput-module__sendButton___WUQI8 .SendSmsInput-module__icon___iJep7 {
  width: 24px;
  height: 24px;
}
.SendSmsInput-module__container___iiaou .SendSmsInput-module__buttonContainer___yScpa .SendSmsInput-module__scheduleButton___o8O66 {
  position: absolute;
  top: 50%;
  right: -60px;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
}
.SendSmsInput-module__container___iiaou .SendSmsInput-module__buttonContainer___yScpa .SendSmsInput-module__scheduleButton___o8O66 .SendSmsInput-module__icon___iJep7 {
  width: 36px;
  height: 36px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/fragments/TimelineFragment/SendSmsInput/SendSmsInput.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,eAAA;EACA,SAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;AA8pBF;AA5pBE;EACE,UAAA;EACA,kBAAA;AA8pBJ;AA5pBI;EACE,yBAAA;EACA,qBAAA;EACA,oBAAA;AA8pBN;AA5pBM;EACE,wCAAA;AA8pBR;AAzpBE;EACE,aAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;AA2pBJ;AAzpBI;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;AA2pBN;AAzpBM;EACE,aAAA;EACA,mBAAA;AA2pBR;AAxpBM;EACE,WAAA;EACA,YAAA;AA0pBR;AAtpBI;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;AAwpBN;AAtpBM;EACE,WAAA;EACA,YAAA;AAwpBR","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  position: fixed;\n  bottom: 0;\n  margin: 40px auto;\n  display: flex;\n  align-self: center;\n  width: 100%;\n  justify-content: center;\n\n  .inputContainer {\n    width: 50%;\n    position: relative;\n\n    .input {\n      background-color: get-color(grayNew, ultra-light);\n      border-color: get-color(grayNew, medium);\n      padding-right: 100px;\n\n      &.error {\n        background-color: get-color(redNew, light);\n      }\n    }\n  }\n\n  .buttonContainer {\n    display: flex;\n    position: absolute;\n    right: 26%;\n    top: 21px;\n    gap: 20px;\n    \n    .sendButton {\n      display: flex;\n      width: 40px;\n      height: 40px;\n      align-items: center;\n      justify-content: center;\n      border-radius: 50%;\n      background-color: get-color(greenNew, dark);\n      cursor: pointer;\n  \n      &.disabled {\n        opacity: 0.33;\n        cursor: not-allowed;\n      }\n  \n      .icon {\n        width: 24px;\n        height: 24px;\n      }\n    }\n\n    .scheduleButton {\n      position: absolute;\n      top: 50%;\n      right: -60px; // Outside the text area\n      transform: translateY(-50%);\n      width: 40px;\n      height: 40px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border-radius: 50%;\n      cursor: pointer;\n  \n      .icon {\n        width: 36px;\n        height: 36px;\n      }\n    }\n  }\n  \n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `SendSmsInput-module__font-s-10___yuJiU`,
	"fontS12": `SendSmsInput-module__font-s-12___HVQY1`,
	"fontS13": `SendSmsInput-module__font-s-13___N2ATT`,
	"fontS14": `SendSmsInput-module__font-s-14___TsHUr`,
	"fontS15": `SendSmsInput-module__font-s-15___W15rb`,
	"fontS16": `SendSmsInput-module__font-s-16___D9dkT`,
	"fontS18": `SendSmsInput-module__font-s-18___H7qs3`,
	"fontS20": `SendSmsInput-module__font-s-20___S6F_6`,
	"fontS22": `SendSmsInput-module__font-s-22___ZtepK`,
	"fontS28": `SendSmsInput-module__font-s-28___RyTZJ`,
	"fontW400": `SendSmsInput-module__font-w-400___M3vvp`,
	"fontW500": `SendSmsInput-module__font-w-500___pZDdz`,
	"fontW600": `SendSmsInput-module__font-w-600___gv7Iq`,
	"fontW700": `SendSmsInput-module__font-w-700___DLDaP`,
	"p5": `SendSmsInput-module__p-5___LahIl`,
	"p12": `SendSmsInput-module__p-12___LLx4b`,
	"p16": `SendSmsInput-module__p-16___i1XOE`,
	"p30": `SendSmsInput-module__p-30___ikEGA`,
	"pB0": `SendSmsInput-module__p-b-0___LCzGO`,
	"pB5": `SendSmsInput-module__p-b-5___a4gYP`,
	"pB10": `SendSmsInput-module__p-b-10___qnHIs`,
	"pB12": `SendSmsInput-module__p-b-12___d6MLK`,
	"pB16": `SendSmsInput-module__p-b-16___PHxGH`,
	"pB18": `SendSmsInput-module__p-b-18___SF0PY`,
	"pB20": `SendSmsInput-module__p-b-20___f4kGQ`,
	"pB25": `SendSmsInput-module__p-b-25___XyTDQ`,
	"pB30": `SendSmsInput-module__p-b-30___pjAlB`,
	"pB50": `SendSmsInput-module__p-b-50___mKyeC`,
	"pT0": `SendSmsInput-module__p-t-0___iIcu4`,
	"pT12": `SendSmsInput-module__p-t-12___HOJAx`,
	"pT16": `SendSmsInput-module__p-t-16___GSAmf`,
	"pT18": `SendSmsInput-module__p-t-18___lqMJs`,
	"pT20": `SendSmsInput-module__p-t-20___Z5kLh`,
	"pT30": `SendSmsInput-module__p-t-30___jw7LQ`,
	"pT40": `SendSmsInput-module__p-t-40___luf6i`,
	"pT50": `SendSmsInput-module__p-t-50___y48Pm`,
	"pL20": `SendSmsInput-module__p-l-20___ynDJe`,
	"pL30": `SendSmsInput-module__p-l-30___H5cgx`,
	"pL40": `SendSmsInput-module__p-l-40___aXMqP`,
	"pR16": `SendSmsInput-module__p-r-16___v6vzJ`,
	"pR20": `SendSmsInput-module__p-r-20____RGXz`,
	"pR30": `SendSmsInput-module__p-r-30___jUGKR`,
	"pR50": `SendSmsInput-module__p-r-50___lZ33F`,
	"pR60": `SendSmsInput-module__p-r-60___MySm1`,
	"mB1": `SendSmsInput-module__m-b-1___yRml6`,
	"mB2": `SendSmsInput-module__m-b-2___YBJWK`,
	"mB6": `SendSmsInput-module__m-b-6___d3CWo`,
	"mB8": `SendSmsInput-module__m-b-8___BJ23i`,
	"mB10": `SendSmsInput-module__m-b-10___faN_b`,
	"mB14": `SendSmsInput-module__m-b-14___mEqBh`,
	"mB16": `SendSmsInput-module__m-b-16___ayQK_`,
	"mB20": `SendSmsInput-module__m-b-20___VxATl`,
	"mB22": `SendSmsInput-module__m-b-22___LXBXX`,
	"mB24": `SendSmsInput-module__m-b-24___qTO4x`,
	"mB30": `SendSmsInput-module__m-b-30___Hj5Ht`,
	"mB32": `SendSmsInput-module__m-b-32___sj7Hh`,
	"mB40": `SendSmsInput-module__m-b-40___MtvQS`,
	"mT2": `SendSmsInput-module__m-t-2___dGvU8`,
	"mT3": `SendSmsInput-module__m-t-3___8AhPy`,
	"mT4": `SendSmsInput-module__m-t-4___VHXya`,
	"mT5": `SendSmsInput-module__m-t-5___xmb_i`,
	"mT8": `SendSmsInput-module__m-t-8___cHSC9`,
	"mT10": `SendSmsInput-module__m-t-10___JkgWM`,
	"mT15": `SendSmsInput-module__m-t-15___QTPFn`,
	"mT16": `SendSmsInput-module__m-t-16___sp0Z7`,
	"mT20": `SendSmsInput-module__m-t-20___bWptq`,
	"mT22": `SendSmsInput-module__m-t-22___hdmDF`,
	"mT30": `SendSmsInput-module__m-t-30___TDYkZ`,
	"mT32": `SendSmsInput-module__m-t-32___eRqwJ`,
	"mLAuto": `SendSmsInput-module__m-l-auto___JJQz5`,
	"mL4": `SendSmsInput-module__m-l-4___oD9g_`,
	"mL5": `SendSmsInput-module__m-l-5___hYC88`,
	"mL6": `SendSmsInput-module__m-l-6___jS8CR`,
	"mL8": `SendSmsInput-module__m-l-8___B8Tq2`,
	"mL10": `SendSmsInput-module__m-l-10____FyYw`,
	"mL16": `SendSmsInput-module__m-l-16___q0eyK`,
	"mL20": `SendSmsInput-module__m-l-20____ZmmW`,
	"mL24": `SendSmsInput-module__m-l-24___FXgZ8`,
	"mL30": `SendSmsInput-module__m-l-30___WJU4C`,
	"mL35": `SendSmsInput-module__m-l-35___bjKk2`,
	"mL40": `SendSmsInput-module__m-l-40___GOOWi`,
	"mR8": `SendSmsInput-module__m-r-8___tRfM_`,
	"mR10": `SendSmsInput-module__m-r-10___lLfcO`,
	"mR16": `SendSmsInput-module__m-r-16___INMv7`,
	"mR20": `SendSmsInput-module__m-r-20___ma2Cs`,
	"mR24": `SendSmsInput-module__m-r-24___jOJW8`,
	"mR30": `SendSmsInput-module__m-r-30___E4m_w`,
	"mR40": `SendSmsInput-module__m-r-40___Wi4op`,
	"borderR3": `SendSmsInput-module__border-r-3___PaOWt`,
	"borderR4": `SendSmsInput-module__border-r-4___xFoEY`,
	"borderR6": `SendSmsInput-module__border-r-6___ZPCZM`,
	"borderR10": `SendSmsInput-module__border-r-10___Frp40`,
	"borderR12": `SendSmsInput-module__border-r-12___ZIeRK`,
	"borderR16": `SendSmsInput-module__border-r-16___akmDU`,
	"borderR50": `SendSmsInput-module__border-r-50___k_QID`,
	"primaryBorder": `SendSmsInput-module__primary-border___oDWf1`,
	"primaryBorderB": `SendSmsInput-module__primary-border-b___rRU_5`,
	"primaryBorderT": `SendSmsInput-module__primary-border-t___pp6PW`,
	"primaryBorderL": `SendSmsInput-module__primary-border-l___XBEAH`,
	"primaryBorderR": `SendSmsInput-module__primary-border-r___wiheB`,
	"secondaryBorder": `SendSmsInput-module__secondary-border___vpGCy`,
	"secondaryBorderB": `SendSmsInput-module__secondary-border-b___cNyTg`,
	"secondaryBorderT": `SendSmsInput-module__secondary-border-t___X7rws`,
	"secondaryBorderL": `SendSmsInput-module__secondary-border-l___y8ive`,
	"secondaryBorderR": `SendSmsInput-module__secondary-border-r___je4On`,
	"gap0": `SendSmsInput-module__gap-0___fHAzG`,
	"gap2": `SendSmsInput-module__gap-2___utnM4`,
	"gap4": `SendSmsInput-module__gap-4___kVO_R`,
	"gap5": `SendSmsInput-module__gap-5___Jo0Q5`,
	"gap6": `SendSmsInput-module__gap-6___kW1gT`,
	"gap8": `SendSmsInput-module__gap-8___AnPlk`,
	"gap10": `SendSmsInput-module__gap-10___u2Ld1`,
	"gap12": `SendSmsInput-module__gap-12___aq44S`,
	"gap14": `SendSmsInput-module__gap-14___zNqTd`,
	"gap16": `SendSmsInput-module__gap-16___awOmL`,
	"gap18": `SendSmsInput-module__gap-18___E9nYg`,
	"gap20": `SendSmsInput-module__gap-20___QUdgJ`,
	"gap24": `SendSmsInput-module__gap-24___eCDI3`,
	"gap26": `SendSmsInput-module__gap-26___xYdP8`,
	"gap30": `SendSmsInput-module__gap-30___G5nmY`,
	"gap32": `SendSmsInput-module__gap-32___uQCjV`,
	"gap40": `SendSmsInput-module__gap-40___seTT5`,
	"gap50": `SendSmsInput-module__gap-50___VzSyE`,
	"flex1": `SendSmsInput-module__flex-1___DsMBb`,
	"flexNone": `SendSmsInput-module__flex-none___lMlLV`,
	"flexColumn": `SendSmsInput-module__flex-column___ZFAy7`,
	"flexRow": `SendSmsInput-module__flex-row___BT9c1`,
	"verticallyCentered": `SendSmsInput-module__vertically-centered___kUOs5`,
	"horizontallyCentered": `SendSmsInput-module__horizontally-centered___Xmya0`,
	"horizontallyEnd": `SendSmsInput-module__horizontally-end___FY_CJ`,
	"verticallyStart": `SendSmsInput-module__vertically-start___wD1yS`,
	"spaceBetween": `SendSmsInput-module__space-between___NXAar`,
	"flexWrap": `SendSmsInput-module__flex-wrap___U_MZE`,
	"height100": `SendSmsInput-module__height-100___m1Hu4`,
	"width50": `SendSmsInput-module__width-50___vItYn`,
	"width100": `SendSmsInput-module__width-100___XrVQn`,
	"cursorPointer": `SendSmsInput-module__cursor-pointer___Ln6Gu`,
	"cursorNotAllowed": `SendSmsInput-module__cursor-not-allowed___CQ4A6`,
	"absoluteCentered": `SendSmsInput-module__absolute-centered___jpsAc`,
	"absolute": `SendSmsInput-module__absolute___WBjbb`,
	"relative": `SendSmsInput-module__relative___VDmm8`,
	"fixed": `SendSmsInput-module__fixed___uVQEc`,
	"visible": `SendSmsInput-module__visible___6WGw8`,
	"invisible": `SendSmsInput-module__invisible___gRaaA`,
	"col90": `SendSmsInput-module__col-90___Zbp6A`,
	"colAuto": `SendSmsInput-module__col-auto___a0FRz`,
	"medicalTabs": `SendSmsInput-module__medical-tabs___sLnJ2`,
	"medicalTableNew": `SendSmsInput-module__medical-table-new___gQSp8`,
	"noPagination": `SendSmsInput-module__no-pagination___TsRrz`,
	"medicalTableEmpty": `SendSmsInput-module__medical-table-empty___b1WAF`,
	"iconBtn": `SendSmsInput-module__icon-btn___Pburf`,
	"searchIcon": `SendSmsInput-module__search-icon___I80wP`,
	"disableSelect": `SendSmsInput-module__disable-select___wpQDl`,
	"breakWord": `SendSmsInput-module__break-word___lJz_f`,
	"popupClearBtn": `SendSmsInput-module__popup-clear-btn___tXQ1b`,
	"scrollMB20": `SendSmsInput-module__scroll-m-b-20___WhGzM`,
	"container": `SendSmsInput-module__container___iiaou`,
	"inputContainer": `SendSmsInput-module__inputContainer___F9Tgn`,
	"input": `SendSmsInput-module__input___bdQMQ`,
	"error": `SendSmsInput-module__error___CsN5Z`,
	"buttonContainer": `SendSmsInput-module__buttonContainer___yScpa`,
	"sendButton": `SendSmsInput-module__sendButton___WUQI8`,
	"disabled": `SendSmsInput-module__disabled___vHtIc`,
	"icon": `SendSmsInput-module__icon___iJep7`,
	"scheduleButton": `SendSmsInput-module__scheduleButton___o8O66`
};
module.exports = ___CSS_LOADER_EXPORT___;
